/* ============================================================
   IGNITE — P8 + V600 PROMO (v8, batch add fix)

   FIX FATA DE V7:
   - Folosesc /cart/add.js cu format BATCH ({items: [...]})
     in loc de Promise.all (cart endpoints nu accepta paralel!)
   - Un singur apel pentru toate adaugarile -> atomic + rapid
   ============================================================ */

(function () {
  'use strict';

  var CONFIG = {
    p8VariantId: 54500242325833,
    v600VariantIds: [
      46754223653193, 46754223685961, 46754223718729,
      46754223751497, 46754223784265
    ],
    promoProperty: '_ignite_promo',
    promoValue: 'p8-v600-free',
    parentProperty: '_promo_parent',
    parentValue: 'p8-starter-kit',
    lockedProperty: '_promo_locked',
    lockedValue: 'true',
    pollingInterval: 5000,
    syncDebounce: 400,
    storageKey: 'ignite_p8_promo_state',
    debug: true
  };

  var P8_ID = String(CONFIG.p8VariantId);
  var V600_IDS = CONFIG.v600VariantIds.map(String);

  window.__p8PromoSyncing = window.__p8PromoSyncing || false;
  var syncDebounceTimer = null;
  var lastCartSignature = '';

  function log() {
    if (!CONFIG.debug) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[P8 Promo]');
    console.log.apply(console, args);
  }

  log('Script v8 (batch add) loaded.');

  function loadState() {
    try {
      var raw = localStorage.getItem(CONFIG.storageKey);
      if (!raw) return { lastP8Qty: 0 };
      var data = JSON.parse(raw);
      return { lastP8Qty: data.lastP8Qty || 0 };
    } catch (e) {
      return { lastP8Qty: 0 };
    }
  }

  function saveState(state) {
    try {
      localStorage.setItem(CONFIG.storageKey, JSON.stringify(state));
    } catch (e) { }
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('fetchCart: HTTP ' + r.status);
        return r.json();
      });
  }

  function cartSignature(cart) {
    return cart.items.map(function (i) {
      return i.variant_id + ':' + i.quantity + ':' + i.key;
    }).join('|');
  }

  function getTotalQty(cart, variantId) {
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === variantId) {
        total += cart.items[i].quantity;
      }
    }
    return total;
  }

  function isPromoLineItem(item) {
    if (!item.properties) return false;
    return item.properties[CONFIG.promoProperty] === CONFIG.promoValue;
  }

  function findAllPromoLineItems(cart, variantId) {
    var items = [];
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (String(item.variant_id) === variantId && isPromoLineItem(item)) {
        items.push(item);
      }
    }
    return items;
  }

  function batchUpdateByKeys(updates) {
    log('Batch update by keys:', updates);
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) {
        return r.text().then(function (txt) {
          throw new Error('batchUpdate: HTTP ' + r.status + ' --- ' + txt);
        });
      }
      return r.json();
    });
  }

  /**
   * BATCH ADD: trimite mai multe items intr-un singur apel /cart/add.js.
   * Asta e atomic si evita bug-ul cu apeluri paralele la cart endpoints.
   *
   * Format: { items: [{id, quantity, properties}, ...] }
   */
  function batchAddItems(itemsToAdd) {
    log('Batch add:', itemsToAdd.length, 'items');
    var properties = {};
    properties[CONFIG.promoProperty] = CONFIG.promoValue;
    properties[CONFIG.parentProperty] = CONFIG.parentValue;
    properties[CONFIG.lockedProperty] = CONFIG.lockedValue;

    var items = itemsToAdd.map(function (a) {
      return {
        id: parseInt(a.variantId, 10),
        quantity: a.quantity,
        properties: properties
      };
    });

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) {
        return r.text().then(function (txt) {
          throw new Error('batchAdd: HTTP ' + r.status + ' --- ' + txt);
        });
      }
      return r.json();
    });
  }

  // ====== BADGE UPDATE ======

  function updateCartBadgeFromCart(cart) {
    try {
      var count = (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;
      var badgeSelectors = [
        '[data-cart-count]',
        '[data-header-cart-count]',
        '.cart-count',
        '.cart-icon-count',
        '.header-cart__count',
        '.header__cart-count',
        '.header-cart-count',
        '.cart-link__count',
        '.cart-link__bubble',
        '.cart-icon__count',
        '#CartCount',
        '#cart-count',
        '.cart__counter',
        '.cart-button__count',
        '.site-header__cart-count'
      ];

      badgeSelectors.forEach(function (sel) {
        try {
          var els = document.querySelectorAll(sel);
          els.forEach(function (el) {
            try { el.textContent = String(count); } catch (e) { }
          });
        } catch (e) { }
      });
    } catch (e) {
      console.warn('[P8 Promo] Badge update failed:', e.message);
    }
  }

  function aggressiveBadgeUpdate() {
    fetchCart().then(function (cart) {
      updateCartBadgeFromCart(cart);
      setTimeout(function () { updateCartBadgeFromCart(cart); }, 100);
      setTimeout(function () { updateCartBadgeFromCart(cart); }, 300);
      setTimeout(function () { updateCartBadgeFromCart(cart); }, 600);
    }).catch(function () { });
  }

  // ====== SYNC LOGIC ======

  function syncPromo() {
    if (window.__p8PromoSyncing) return Promise.resolve(null);
    window.__p8PromoSyncing = true;
    log('--- Sync starting ---');

    return fetchCart()
      .then(function (cart) {
        var state = loadState();
        var currentP8 = getTotalQty(cart, P8_ID);
        var lastP8 = state.lastP8Qty;

        log('Cart: items=' + cart.items.length + ', total=' + (cart.total_price / 100));
        log('P8: last=' + lastP8 + ', current=' + currentP8);

        if (cart.items.length === 0) {
          saveState({ lastP8Qty: 0 });
          lastCartSignature = cartSignature(cart);
          updateCartBadgeFromCart(cart);
          return null;
        }

        var keyUpdates = {};
        var newAdds = [];
        var anyChanges = false;

        if (currentP8 === 0) {
          V600_IDS.forEach(function (variantId) {
            var promoItems = findAllPromoLineItems(cart, variantId);
            promoItems.forEach(function (item) {
              keyUpdates[item.key] = 0;
              anyChanges = true;
              log('  V600 ' + variantId + ': remove (P8=0)');
            });
          });
          saveState({ lastP8Qty: 0 });
        } else {
          // P8 > 0

          // PAS A: daca P8 a scazut, scad cu delta pe promo
          if (currentP8 < lastP8) {
            var delta = lastP8 - currentP8;
            log('P8 decreased by ' + delta);

            V600_IDS.forEach(function (variantId) {
              var promoItems = findAllPromoLineItems(cart, variantId);
              if (promoItems.length === 0) return;
              var primary = promoItems[0];
              var newQty = Math.max(0, primary.quantity - delta);
              if (newQty !== primary.quantity) {
                keyUpdates[primary.key] = newQty;
                anyChanges = true;
                log('  V600 ' + variantId + ': scade ' + primary.quantity + ' -> ' + newQty);
              }
            });
          }

          // PAS B: asigur ca exista MINIM currentP8 promo per V600
          V600_IDS.forEach(function (variantId) {
            var promoItems = findAllPromoLineItems(cart, variantId);
            var effectivePromoQty = promoItems.reduce(function (s, item) {
              if (keyUpdates.hasOwnProperty(item.key)) {
                return s + keyUpdates[item.key];
              }
              return s + item.quantity;
            }, 0);

            if (effectivePromoQty < currentP8) {
              var needed = currentP8 - effectivePromoQty;
              log('  V600 ' + variantId + ': promo=' + effectivePromoQty + ', P8=' + currentP8 + ', need +' + needed);

              if (promoItems.length === 0) {
                newAdds.push({ variantId: variantId, quantity: needed });
                anyChanges = true;
                log('  V600 ' + variantId + ': add new line qty=' + needed);
              } else {
                var primary2 = promoItems[0];
                var currentEffective = keyUpdates.hasOwnProperty(primary2.key)
                  ? keyUpdates[primary2.key]
                  : primary2.quantity;
                keyUpdates[primary2.key] = currentEffective + needed;
                anyChanges = true;
                log('  V600 ' + variantId + ': fill ' + currentEffective + ' -> ' + (currentEffective + needed));
              }
            }
          });

          saveState({ lastP8Qty: currentP8 });
        }

        if (!anyChanges) {
          log('Already in sync');
          lastCartSignature = cartSignature(cart);
          updateCartBadgeFromCart(cart);
          return null;
        }

        var chain = Promise.resolve(cart);

        // PRIMA: update by keys
        if (Object.keys(keyUpdates).length > 0) {
          chain = chain.then(function () {
            return batchUpdateByKeys(keyUpdates);
          });
        }

        // APOI: BATCH add (toate items intr-un singur apel)
        if (newAdds.length > 0) {
          chain = chain.then(function () {
            return batchAddItems(newAdds).then(function () {
              return fetchCart();
            });
          });
        }

        return chain.then(function (finalCart) {
          log('Sync complete with changes');
          lastCartSignature = cartSignature(finalCart);
          notifyCartChanged(finalCart);
          return finalCart;
        });
      })
      .catch(function (err) {
        console.warn('[P8 Promo] Sync failed:', err.message);
      })
      .then(function (result) {
        window.__p8PromoSyncing = false;
        log('--- Sync done ---');
        return result;
      });
  }

  function scheduleSync() {
    if (syncDebounceTimer) clearTimeout(syncDebounceTimer);
    syncDebounceTimer = setTimeout(syncPromo, CONFIG.syncDebounce);
  }

  // ====== REFRESH ======

  function refreshCartDrawer(cart) {
    updateCartBadgeFromCart(cart);

    var events = ['cart:refresh', 'cart:change', 'cart:updated', 'cart:reload'];
    events.forEach(function (ev) {
      try {
        document.dispatchEvent(new CustomEvent(ev, { bubbles: true, detail: { cart: cart } }));
        window.dispatchEvent(new CustomEvent(ev, { bubbles: true, detail: { cart: cart } }));
      } catch (e) { }
    });

    if (window.location.pathname.indexOf('/cart') === 0) {
      setTimeout(function () { window.location.reload(); }, 300);
      return;
    }

    fetch('/?sections=mini-cart,cart-drawer,cart,header,site-header', {
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        Object.keys(sections).forEach(function (sectionId) {
          var html = sections[sectionId];
          if (!html) return;
          var selectors = [
            '#shopify-section-' + sectionId,
            '[data-section-id="' + sectionId + '"]'
          ];
          selectors.forEach(function (sel) {
            try {
              var elements = document.querySelectorAll(sel);
              elements.forEach(function (el) {
                try {
                  var parser = new DOMParser();
                  var doc = parser.parseFromString(html, 'text/html');
                  var newSection = doc.querySelector(sel) || doc.body.firstElementChild;
                  if (newSection) {
                    el.innerHTML = newSection.innerHTML;
                  }
                } catch (e) { }
              });
            } catch (e) { }
          });
        });

        updateCartBadgeFromCart(cart);
        setTimeout(function () { updateCartBadgeFromCart(cart); }, 200);

        try {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        } catch (e) { }
      })
      .catch(function () { });
  }

  function notifyCartChanged(cart) {
    refreshCartDrawer(cart);
  }

  // ====== INTERCEPTORI ======

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var isCartMutation = (
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1 ||
      url.indexOf('/cart/clear') !== -1
    );
    var promise = originalFetch.apply(this, arguments);
    if (isCartMutation && !window.__p8PromoSyncing) {
      promise.then(function (response) {
        if (response && response.ok) {
          log('Cart mutation:', url.split('?')[0]);
          aggressiveBadgeUpdate();
          scheduleSync();
        }
      }).catch(function () { });
    }
    return promise;
  };

  var originalXHROpen = XMLHttpRequest.prototype.open;
  var originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._p8PromoCartUrl = url;
    return originalXHROpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    var url = self._p8PromoCartUrl || '';
    var isCartMutation = (
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1 ||
      url.indexOf('/cart/clear') !== -1
    );
    if (isCartMutation && !window.__p8PromoSyncing) {
      self.addEventListener('load', function () {
        if (self.status >= 200 && self.status < 300) {
          log('Cart mutation (XHR):', url.split('?')[0]);
          aggressiveBadgeUpdate();
          scheduleSync();
        }
      });
    }
    return originalXHRSend.apply(this, arguments);
  };

  setInterval(function () {
    if (window.__p8PromoSyncing) return;
    fetchCart().then(function (cart) {
      var sig = cartSignature(cart);
      if (sig !== lastCartSignature) {
        log('Polling detected change');
        lastCartSignature = sig;
        updateCartBadgeFromCart(cart);
        scheduleSync();
      }
    }).catch(function () { });
  }, CONFIG.pollingInterval);

  function init() {
    log('Init. State:', loadState());
    fetchCart().then(function (cart) {
      lastCartSignature = cartSignature(cart);
      updateCartBadgeFromCart(cart);
      scheduleSync();
    }).catch(function () { });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();